import { Box, styled } from '@mui/material'
import { WallChartContainerProps } from './types'
import Card, { CardProps } from '../../shared/layout/Card'

export const WallChartContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'margin',
})<WallChartContainerProps>(({ margin }) => ({
  ...{ margin },
})) as React.ComponentType<WallChartContainerProps>

export const WallChartRowsBoxContainer = styled(Box)`
  overflow-y: scroll;
  overflow-x: hidden;
  flex: 1;
  position: relative;
  &::-webkit-scrollbar {
    width: 6px;
  }
`

export const WallChartRowItem = styled(Box)``

export const RowName = styled('span', {
  shouldForwardProp: prop => prop !== 'margin',
})<WallChartContainerProps>(() => ({
  fontFamily: 'Poppins',
  fontSize: '12px',
  fontWeight: 600,
  width: '100px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})) as React.ComponentType<WallChartContainerProps>

export function WallChartCard ({ title, children, isWallChartView }: CardProps & { isWallChartView: boolean }) {
  return (
    <Card title={title} padding="24px 32px" style={{ maxHeight: isWallChartView ? "calc(100vh - 184px)" : undefined }}>
      {children}
    </Card>
  )
}